import { render, staticRenderFns } from "./accomodationList.vue?vue&type=template&id=b7b35aaa&scoped=true&"
import script from "./accomodationList.vue?vue&type=script&lang=js&"
export * from "./accomodationList.vue?vue&type=script&lang=js&"
import style0 from "./accomodationList.vue?vue&type=style&index=0&id=b7b35aaa&prod&scoped=true&lang=css&"
import style1 from "./accomodationList.vue?vue&type=style&index=1&id=b7b35aaa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b35aaa",
  null
  
)

export default component.exports